import { OpeningstijdenDto } from "@/shared/types";

export type Openingstijden = {
    dag: number; // 1-7 (1=maandag ... 7=zondag)
    openVan: string; // HH:MM
    openTot: string; // HH:MM
};

export const Openingstijden = {
    fromDto: (dto: OpeningstijdenDto): Openingstijden => ({
        dag: dto.dag,
        openVan: dto.openVan,
        openTot: dto.openTot,
    }),

    toDto: (domain: Openingstijden): OpeningstijdenDto => ({
        dag: domain.dag,
        openVan: domain.openVan,
        openTot: domain.openTot,
    }),
};
